var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DropDownMultiSelectSearch',{attrs:{"darkenWhenActive":_vm.darkenWhenActive,"multiselect":false,"name":_vm.itemTypeName,"options":_vm.options,"showFullValueText":true,"value":[_vm.value]},on:{"input":_vm.handleInput,"open":_vm.handleOpenEvent}})
}
var staticRenderFns = []

export { render, staticRenderFns }